module.exports = __webpack_public_path__ + "static/img/img_contact us.34afe3f4.png";